import { createRouter, createWebHashHistory } from 'vue-router'
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/overview/_index.vue'),//暂时
    // component: () => import('@/views/bankDetail/index.vue'),
    children: [
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login.vue'),
    meta: {
      name: 'login',
      title: 'login'
    },
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/views/bankDetail/index.vue')
  },
  {
    path: '/myInfo',
    name: 'myInfo',
    component: () => import('@/views/overview/components/operation-records.vue')
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage'),
    meta: {
      name: '404',
      title: '404'
    },
  },
  {
    path: '/:pathMatch(.*)', 
    redirect: '/404'
  },
  {
    path: '/noneRole',
    component: () => import('@/views/noneRole'),
    meta: {
      name: 'noneRole',
      title: 'noneRole'
    },
  },
  {
    path: '/rem-demo',
    name: 'remDemo',
    component: () => import('@/views/rem-demo.vue'),
    meta: {
      name: 'remDemo',
      title: 'Rem自适应演示'
    },
  }
]

const router = createRouter({
  history: createWebHashHistory('/uca'),
  routes
})
export default router